import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.LOAD_MASTERS] (state, data) {
    console.log(types.LOAD_MASTERS, data)
    Vue.set(state, data.id, data.data)
  }
}
